const DAILY_VIBE_INVITER_SESSION_KEY = 'luvwtf_dailyVibeInviterUid';

/** Persist inviter uid from email invite deeplink until the friend signs in. */
export function captureDailyVibeInviteFromSearchParams(searchParams) {
  if (!searchParams) return;
  const inviter = searchParams.get('dailyVibeInviter');
  if (!inviter || !String(inviter).trim()) return;
  try {
    sessionStorage.setItem(DAILY_VIBE_INVITER_SESSION_KEY, String(inviter).trim());
  } catch (_) {}
}

export function peekDailyVibeInviterUid() {
  try {
    const value = sessionStorage.getItem(DAILY_VIBE_INVITER_SESSION_KEY);
    return value && String(value).trim() ? String(value).trim() : null;
  } catch (_) {
    return null;
  }
}

export function consumeDailyVibeInviterUid() {
  const value = peekDailyVibeInviterUid();
  try {
    sessionStorage.removeItem(DAILY_VIBE_INVITER_SESSION_KEY);
  } catch (_) {}
  return value;
}
